
import { Navigate } from 'react-router-dom';
import {
  LOGOUT,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  GET_TOKEN,
 
} from '../Constants/ActionTypes.js';


export const loginReducer = (state = { loginData: null, isLoading: false }, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, isLoading: true };
    case LOGIN_SUCCESS:
      localStorage.setItem('access_token', JSON.stringify(action.payload.data));
      return { ...state, loginData: action.payload.data, isLoading: false };
    case GET_TOKEN: 
    return {...state,loginData:action.payload.data.token,isLoading:false}
    case LOGIN_FAILURE:
      return { ...state, isLoading: false };
    case LOGOUT:
      localStorage.clear();
      return { ...state, loginData: null, isLoading: false };
    default:
      return state;
  }
};
